import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TdDialogService, TdLoadingService } from '@covalent/core';
import { Route } from '@angular/router/src/config';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { Receiving } from '../../../receiving/receiving';
import { ReceivingService } from '../../../receiving/receiving.service';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../../accounting/branch';

@Component({
  selector: 'app-scan',
  templateUrl: './scan.component.html',
  styleUrls: ['./scan.component.scss']
})
export class ScanComponent implements OnInit {
  received_orders: Receiving[];

  filtered_received_orders: Receiving[];

  receivingNumber: string;
  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';
  

  constructor(private router: Router,
    private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _receivingService: ReceivingService,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.getPackingListReceivings();

    //Use this person's branches instead
    //this.allBranches$ = this._receivingService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
    // Then default to user's home branch
    this.branchFilter = this._authService.getUserBranches().find(b=>{ return b.id == this._authService.getHomeBranch() }).code
  }

  goBack(): void {
    this.location.back();
  }

  getPackingListReceivings() {
    this._loadingService.register('loading');

    this._receivingService.getReceivings().subscribe(
      response => {
        this.received_orders = response.filter(function(o){ return o.status=='PACKING LIST'});

        this.filter();
        this._loadingService.resolve('loading');
      }
    );
  }

  filter(): void {
    let newData: Receiving[] = this.received_orders;
    
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['requesting_branch_code'] == this.branchFilter });
    }

    this.filtered_received_orders = newData;
  }



}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/receiving/scan/scan.component.ts